import Request from "../lib/request";
import { PROJECT_ID } from "../constants/storageKeys";
import {
  PROJECTS_API,
  REORDER_API,
  TEAM_LEVEL_USERS_API,
  TEAM_LEVELS_API, TEAM_UPDATE_WIDGET_API,
  TEAMS_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const list = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}`,
    needToken: true,
    data: data
  });
};

export const show = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}`,
    needToken: true
  });
};

export const remove = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}`,
    needToken: true
  });
};

export const store = (projectId, data) => {
  const _projectId = projectId ? projectId : localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${_projectId}/${TEAMS_API}`,
    needToken: true,
    data: data
  });
};

export const update = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}`,
    needToken: true,
    data: data
  });
};

export const getLevels = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}`,
    needToken: true
  });
};

export const showLevel = (id, levelId) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}`,
    needToken: true
  });
};

export const removeLevel = (id, levelId) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}`,
    needToken: true
  });
};

export const storeLevel = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}`,
    needToken: true,
    data: data
  });
};

export const updateLevel = (id, levelId, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}`,
    needToken: true,
    data: data
  });
};

export const reorderLevels = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${REORDER_API}`,
    needToken: true,
    data: data
  });
};

export const removeLevelApprover = (id, levelId, userId) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}/${TEAM_LEVEL_USERS_API}/${userId}`,
    needToken: true
  });
};

export const getLevelApprovers = (id, levelId) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}/${TEAM_LEVEL_USERS_API}`,
    needToken: true
  });
};

export const storeLevelApprover = (id, levelId, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_LEVELS_API}/${levelId}/${TEAM_LEVEL_USERS_API}`,
    needToken: true,
    data: data
  });
};

export const updateWidgets = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${TEAMS_API}/${id}/${TEAM_UPDATE_WIDGET_API}`,
    needToken: true,
    data: data //{widget: WidgetsEnum, ids: array}
  });
};

